<template>
    <div id="user_list">
        <el-card>
            <div class="AdminTopOper">
                <el-space wrap :size="15">
                    <el-input v-model="pageData.searchKey" placeholder="请输入订单号"></el-input>
                    <el-input style="width: 120px" v-model="pageData.where.id" placeholder="请输入ID"></el-input>
                    <el-button type="primary" icon="Search" @click="orderSearce()">搜索</el-button>
                    <el-button type="primary" icon='Plus' @click="pageData.handleCreate()">新建</el-button>

                    <el-select v-model="pageData.where.status" placeholder="选择订单状态" @change="change">
                        <el-option v-for="withstatus in withstatuslist" :key="withstatus.status"
                            :label="withstatus.name" :value="withstatus.status" />
                    </el-select>
                </el-space>
            </div>

            <!-- 表格主体 -->
            <el-table :data="pageData.rows">
                <el-table-column prop="id" label="编号" width="100" />
                <el-table-column label="提现编号" width="120">
                    <template #default="scope">
                        {{ scope.row.withdrawal_id }}
                    </template>
                </el-table-column>
                <el-table-column label="用户ID" width="80">
                    <template #default="scope">
                        {{ scope.row.userId }}
                    </template>
                </el-table-column>
                <el-table-column label="提现金额" width="90">
                    <template #default="scope">
                        {{ scope.row.amount }} 元
                    </template>
                </el-table-column>
                <el-table-column label="提现状态" width="150">
                    <template #default="scope">
                        <div v-if="scope.row.status == 1">
                            <el-tag type="success">待转账</el-tag>
                        </div>
                        <div v-if="scope.row.status == 2">
                            <el-tag type="warning">已到账</el-tag>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column label="提现备注" width="150">
                    <template #default="scope">
                        {{ scope.row.audit_remark }}
                    </template>
                </el-table-column>
                <el-table-column label="收款码" width="180">
                    <template #default="scope">
                        <img style="height: 200px;" :src="scope.row.receive_code_url" alt="">
                    </template>
                </el-table-column>
                <el-table-column label="联系方式" width="150">
                    <template #default="scope">
                        {{ scope.row.receive_phone }}
                    </template>
                </el-table-column>
                <AdminTableButton :showEdit="true" width="200" fixed="right"> </AdminTableButton>
            </el-table>

            <AdminPagination :showEdit="false"> </AdminPagination>
        </el-card>



        <!-- 新建与编辑dialog -->
        <el-dialog v-model="pageData.dialogVisible" title="新建" width="800px">
            <el-form ref="form" :model="pageData.row" label-width="100px" size='medium'>
                <el-form-item label="提现编号">
                    <el-input v-model="pageData.row.withdrawal_id"></el-input>
                </el-form-item>
                <el-form-item label="提现金额">
                    <el-input v-model="pageData.row.amount"></el-input>
                </el-form-item>
                <el-form-item label="提现状态">
                    <el-input v-model="pageData.row.status"></el-input>
                </el-form-item>
                <el-form-item label="提现备注">
                    <el-input v-model="pageData.row.audit_remark"></el-input>
                </el-form-item>



            </el-form>

            <template #footer>
                <span class="dialog-footer">
                    <el-button @click="pageData.dialogVisible = false">Cancel</el-button>
                    <el-button type="primary" @click="pageData.create()">Confirm</el-button>
                </span>
            </template>
        </el-dialog>
    </div>
</template>

<script setup>
import { ref, onMounted, reactive } from 'vue'
import Api from '@/network'
import COS from 'cos-js-sdk-v5';

import { ElMessage, ElMessageBox } from 'element-plus'
import store from '@/store'
const pageData = reactive(Api.adminPage('withdrawaRecord'))
pageData.where.count = null
onMounted(pageData.getPage())
pageData.where.status =1
let change = () => {
    pageData.getPage()
}
let withstatuslist = [{
    name: '待转账',
    status: 1,
},
{
    name: '已到账',
    status: 2,
}]



const httpRequestFile = (RequestBody) => {

}


</script>



<style lang="less"></style>